import SpinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import Cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import MenuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Util from '@/util'
import Mensagens from '@/util/mensagens'
import FormasPagamento from '../components/FormasPagamento.vue'
import CartaoPagamento from '../components/CartaoPagamento.vue'
import { faturaMixin } from '@/modules/faturas/mixins'
import { formasPagamentoMixins } from '@/modules/formasPagamento/mixins'
import { mapActions, mapState } from 'vuex/dist/vuex.common.js'

export default {
  name: 'formas-pagamento',
  components: {
    SpinnerProcessando,
    FormasPagamento,
    CartaoPagamento,
    Cabecalho,
    MenuLateral
  },
  mixins: [faturaMixin, formasPagamentoMixins],
  data () {
    return {
      cartaoPadrao: false,
      isLoading: false,
      isLoadingCartao: false,
      cartoes: [],
      formulario: {},
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      bandeiraDoCartao: null,
      formasDePagamento: [],
      pagamentoSelecionado: '',
      listaDeErros: {}
    }
  },
  computed: {
    ...mapState('formaspagamento', ['estaCadastrandoCartao', 'formularioFormaDePagamentoCliente'])
  },

  async mounted () {
    this.ActionDefinirFormaPagamentoCliente({ forma_pagamento_selecionado_padrao: '', pagamento_automatico: false, forma_pagamento_idselecionado: '', filho: 'forma_pagamento' })

    this.definirFlagCarregandoDados(true, Mensagens.carregandoDadosEdicao)
    await this.obterCartoes()
    await this.obterFormasDePagamento()
    this.ActionDefinirEstaCadastrandoCartao(false)
  },

  methods: {
    ...mapActions('formaspagamento', ['ActionDefinirEstaCadastrandoCartao', 'ActionDefinirFormaPagamentoCliente']),
    async obterFormasDePagamento () { // Unico
      this.definirFlagCarregandoDados(true, Mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/conta/formas-pagamento`)
        this.formasDePagamento = resposta.data.retorno.dados.formas_pagamento
        if (resposta.data.retorno.dados.resumo.forma_pagamento != null) {
          this.pagamentoSelecionado = this.formasDePagamento.find(r => r.id === resposta.data.retorno.dados.resumo.forma_pagamento)?.nome || ''
          this.ActionDefinirFormaPagamentoCliente({ forma_pagamento_selecionado_padrao: this.pagamentoSelecionado, pagamento_automatico: resposta.data.retorno.dados.pagamento_automatico, forma_pagamento_idselecionado: resposta.data.retorno.dados.resumo.forma_pagamento })
          this.atualizarFormaPagamento(this.formularioFormaDePagamentoCliente.forma_pagamento_selecionado_padrao)
        }
      } catch (e) {
        Util.criarAlertaToastDeErro(this, 'Aviso', Mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, Mensagens.carregandoDadosEdicao)
    },
    async salvarInformacoes () { // Unico
      this.isLoading = true
      this.definirFlagCarregandoDados(true, Mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.post(`/manager/conta/forma-pagamento/salvar`, { forma_pagamento: this.formularioFormaDePagamentoCliente })
        this.obterCartoes()
        await this.obterFormasDePagamento()
        Util.criarAlertaToastDeSucesso(this, 'Aviso', resposta.data.retorno.mensagem)
      } catch (e) {
        Util.criarAlertaToastDeErro(this, 'Aviso', Mensagens.falhaServidorCarregandoDados)
      }
      this.isLoading = false
      this.definirFlagCarregandoDados(false, Mensagens.carregandoDadosEdicao)
    }
  }
}
